import * as yup from 'yup'

const previousMaritalRegimeValidationSchema = yup.object().shape({
    previousRegime: yup
        .string()
        .required('L\'ancien régime doit être selectionné.'),
    weddingPlace: yup
        .string()
        .required('Le lieu du mariage est requis.'),
    weddingDate: yup
        .string()
        .required('La date du mariage est requise')
        .matches(/^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/([0-9]{4})$/, 'Format attendu JJ/MM/AAAA'),
});

export default previousMaritalRegimeValidationSchema;